import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "user-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate" }, "Users")
], -1)
const _hoisted_3 = { class: "dt-container" }
const _hoisted_4 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "You haven't added any users yet.", -1)
const _hoisted_6 = { class: "inventory-table__actions d-sm-flex align-items-end my-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.loading && !_ctx.userSearchResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              class: "mt-3 d-inline-block",
              to: { path: '/users/new'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "px-5 py-3",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add Your First User")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.hasReleaseAccess)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: _ctx.onTurnOnNotification
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Turn on Release Notification")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_input, {
                placeholder: "Search Users",
                modelValue: _ctx.userSearch,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSearch) = $event)),
                onKeyup: _ctx.handleSearchChange
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _createVNode(_component_el_table, {
              data: _ctx.userSearchResults,
              ref: "usersTable",
              onRowDblclick: _ctx.handleCurrentChange,
              onSortChange: _ctx.handleSortChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Name",
                  sortable: "custom"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_router_link, {
                      to: `/admin/users/${scope.row.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "email",
                  label: "Email",
                  sortable: "custom"
                })
              ]),
              _: 1
            }, 8, ["data", "onRowDblclick", "onSortChange"]),
            _hoisted_7,
            _createVNode(_component_el_pagination, {
              class: "d-flex justify-content-center",
              background: "",
              layout: "prev, pager, next",
              total: _ctx.userCount,
              onCurrentChange: _ctx.handleCurrentPageChange,
              "current-page": _ctx.currentPage,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event))
            }, null, 8, ["total", "onCurrentChange", "current-page"])
          ], 64))
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}